import React from 'react';
import { i18n } from '../../../jsCore/providers/i18nProvider/i18nProvider';
const blockName = 'match-date-component';
export default function MatchDate({ date, }){
  const time =  i18n.l("time.formats.hour_minute", date);
  return (
    <div className={ blockName }>
    { time }
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/matchDateScores.js